module.exports = __webpack_public_path__ + "static/img/can-tripleberry-bublyburst.fd4ff99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-tripleberry-bublyburst.png
// module id = calc
// module chunks = 0